export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "heading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Membership limitations"])},
        "limit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limit max members"])},
        "no_limit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No limit"])}
      },
      "fr": {
        "heading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limites d'adhésion"])},
        "limit_count": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre limite"])},
        "limit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre maximum de membres"])},
        "no_limit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sans limite"])}
      }
    }
  })
}